<div class="learner-photos control">
  <h3 class="learner-status">
    <span translate>session-review-id.component.title</span>
    <span
      translate
      [ngClass]="{
        'is-success': identification.status == 'passed',
        'is-failure': identification.status == 'failed'
      }"
    >
      session-review.component.verified.{{ identification.status }}
      <div class="verification-reasons">
        @for (reason of verificationReasons(); track reason) {
          <p>{{ reason }}</p>
        }
      </div>
    </span>
  </h3>

  <table class="control table is-bordered is-narrow">
    <thead>
      <tr>
        <td translate>session-review-id.component.name</td>
        <td translate>session-review-id.component.id</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ session?.learner?.name }}</td>
        <td>{{ session?.learner?.id | idFromGid }}</td>
      </tr>
    </tbody>
  </table>
  <div class="photo control">
    @if (identification) {
      <img [src]="identification.facePhoto.url" />
      <p class="label" translate>session-review-id.component.face-photo</p>
    }
  </div>
  <div class="photo control">
    @if (identification) {
      <img [src]="identification.idPhoto.url" />
      <p class="label" translate>session-review-id.component.id-photo</p>
    }
  </div>
</div>
